import {
  GetDynamicInvoiceDataResponseSchema,
  type DynamicInvoiceIdType,
  type GetDynamicInvoiceDataResponse,
} from '@vy/api-definition';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';
import { queryKeys } from '../../services/query-key/query-keys';
import type { CustomUseQueryOptions } from './requests-types/custom-use-query-options';

export function useDynamicInvoice(
  id: string,
  discriminator: DynamicInvoiceIdType,
  options?: CustomUseQueryOptions<GetDynamicInvoiceDataResponse>,
) {
  return useQuery(
    queryKeys.dynamicInvoice(id),
    async () => {
      const api = getPrivateApi();
      const getDynamicInvoiceDataResponse = await api.getDynamicInvoiceByDiscriminator({ discriminator, id });

      return GetDynamicInvoiceDataResponseSchema.parse(getDynamicInvoiceDataResponse);
    },
    { suspense: true, ...options },
  );
}
